module.exports = __webpack_public_path__ + "img/chirpstack-gateway-bridge-large-dark.09857169.png";